import type { TrialDetailsQuery as TrialDetailsQueryType } from './__types__/TrialDetailsQuery.ts';

export const getLicenseConsumingUserCountFromQuery = (
	queryData: TrialDetailsQueryType | undefined,
) => {
	const userCount = queryData?.license?.licenseConsumingUserCount;
	return userCount === undefined || userCount < 0 ? -1 : userCount;
};
